import {Component, OnInit} from '@angular/core';
import {GridIdentifier} from '@application/grids/grid-identifier.enum';
import {CrudActions} from '@application/helper/grid-action-buttons-helper/crud-actions.interface';
import {GridActionButtonsHelper} from '@application/helper/grid-action-buttons-helper/grid-action-buttons-helper';
import {LastModifiedCardUtils} from '@application/helper/last-modified-card-utils';
import {RemoveConfirmationService} from '@application/helper/remove-confirmation/remove-confirmation.service';
import {RouteUtils} from '@application/helper/routing/route-utils';
import {Shift} from '@domain/calendar/shift/shift';
import {HttpShiftsService} from '@infrastructure/http/calendar/shift/http-shifts.service';
import {
  AssertionUtils,
  CrudOverviewDataBuilderFactoryService,
  CrudOverviewDataConfig,
  GridButtonClickedEvent,
  GridOptionsBuilder,
  NavigationHelperPrototypeService
} from '@vdw/angular-component-library';
import {ShiftOverviewService} from './shift-overview.service';

@Component({
  templateUrl: './shift-overview-page.component.html'
})
export class ShiftOverviewPageComponent implements OnInit {
  public config: CrudOverviewDataConfig<Shift>;

  private readonly GRID_IDENTIFIER = GridIdentifier.SHIFT_OVERVIEW;
  private readonly PAGE_URLS = LastModifiedCardUtils.getPageUrls('shift');
  private readonly SHIFT_TRANSLATION_KEY = 'CALENDAR.SHIFT.SHIFT_CODE';

  public constructor(
    private readonly builderFactoryService: CrudOverviewDataBuilderFactoryService<Shift>,
    private readonly gridActionButtonsHelper: GridActionButtonsHelper,
    private readonly removeConfirmation: RemoveConfirmationService,
    private readonly shifts: HttpShiftsService,
    private readonly shiftOverviewService: ShiftOverviewService,
    private readonly navigationHelper: NavigationHelperPrototypeService
  ) {}

  public ngOnInit(): void {
    this.config = this.builderFactoryService
      .getBuilder()
      .withNewClicked(() => this.navigationHelper.navigateWithRoute({route: this.PAGE_URLS.add}))
      .withDefaultButtons({
        crudOverviewButtonConfigs: this.gridActionButtonsHelper.getActionButtonsForGridSelection({
          requiredPermissionToEdit: RouteUtils.paths.calendar.shift.editShift.requiredPermission,
          withEdit: (grid: GridButtonClickedEvent) => this.navigateToGivenRoute(grid, 'edit'),
          withDuplicate: (grid: GridButtonClickedEvent) => this.navigateToGivenRoute(grid, 'duplicate'),
          withDelete: (grid: GridButtonClickedEvent) => this.delete(grid),
          allowDeleteMultiple: true
        } as CrudActions)
      })
      .withCrudGridOptions(this.shiftOverviewService.getColumnDefs(), this.GRID_IDENTIFIER, null, (builder: GridOptionsBuilder) =>
        this.shiftOverviewService.getDefaultGridOptionsBuilder(builder).withRowSelection(false, false, true).build()
      )
      .withEntityName(this.SHIFT_TRANSLATION_KEY)
      .withRowData(this.shifts.getAll())
      .build();
  }

  private navigateToGivenRoute({gridApi, rowNode}: GridButtonClickedEvent, action: string): void {
    this.navigationHelper.navigateWithRoute({route: this.PAGE_URLS[action].replace(':id', AssertionUtils.isNullOrUndefined(rowNode) ? gridApi?.getSelectedRows()[0].id : rowNode.id)});
  }

  private delete({gridApi, rowNode}: GridButtonClickedEvent): void {
    const data: Shift = AssertionUtils.isNullOrUndefined(rowNode) ? gridApi?.getSelectedRows()[0] : rowNode.data;
    this.removeConfirmation.open(data, this.shifts.delete(data.id), this.SHIFT_TRANSLATION_KEY, gridApi, this.shifts.getConflicts(data.id));
  }
}
